export const FUNC_FISCAL = 1;
export const FUNC_DEFENSOR = 2;

export default [
    {
        id: FUNC_FISCAL,
        descripcion: 'FISCAL'
    },
    {
        id: FUNC_DEFENSOR,
        descripcion: 'DEFENSOR'
    }
];